<script lang="ts">
	let {
		isOwner,
		class: className = ''
	}: {
		isOwner: boolean;
		class?: string;
	} = $props();
</script>

<span
	class="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium {isOwner
		? 'bg-blue-100 text-blue-800'
		: 'bg-gray-100 text-gray-800'} {className}"
>
	{isOwner ? 'Owner' : 'Member'}
</span>
